/**
 * A human-readable message out of anything a rejection can carry.
 *
 * TAURI REJECTS WITH A STRING, not an `Error`. So the very common
 * `err?.message || 'Something failed.'` silently discards the only useful part
 * and shows the fallback — which is how "Could not open the document for
 * printing." reached a user while the actual cause ("Not allowed to open path…")
 * was sitting right there in the rejection.
 */
export function errorMessage(err, fallback = 'Something went wrong.') {
  if (!err) return fallback;
  if (typeof err === 'string') return err.trim() || fallback;
  if (typeof err.message === 'string' && err.message.trim()) return err.message;
  // Plug-in errors sometimes arrive as { message } nested, or as a plain object.
  if (typeof err === 'object') {
    const nested = err.error || err.reason || err.data;
    if (typeof nested === 'string' && nested.trim()) return nested;
    if (nested && typeof nested.message === 'string' && nested.message.trim()) return nested.message;
    try {
      const json = JSON.stringify(err);
      if (json && json !== '{}') return json;
    } catch {
      /* circular — fall through */
    }
  }
  return fallback;
}
